







import settings from '../settings.coffee'

export default {
    "name": ""
    "props": {}
    "computed":{}
}
